import _ from 'lodash'
import Vue from 'vue'

import router from '@/router'
import store from '@/store'
// import { Message } from 'element-ui'
// import Auth from '@/store/api/auth'
// import Setup from './store/api/setup'
// import Store from './store'

// const whiteList = ['/', '/login', '/forgotpassword', '/resetpassword']

router.beforeEach((to, from, next) => {

    let timeout = setTimeout(() => {
        store.commit('isReady', false)

        router.app.$Progress.set(0)
        router.app.$Progress.start()
    }, 50)

    if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        // parse meta tags
        router.app.$Progress.parseMeta(meta)
    }

    store.commit('setError', null)
    setTimeout(() => store.commit('updateSidebarVisibility', false), 150)

    document.title = (to.meta.title) ? to.meta.title : document.title

    const cms = store.getters.CMS.id
    const category = _.get(to.meta, 'category.key')
    const key = _.get(to.params, 'key')

    const skipMiddleware = _.get(to.meta, 'skipMiddleware', false)
    if (skipMiddleware) {
        clearTimeout(timeout)
        store.commit('isReady', true)
        router.app.$Progress.finish()
        return next()
    }

    if (category && key && cms) {
        store.dispatch('currentPage/fetchCategoryPost', { category, key, cms: parseInt(cms) })
            .then(data => {
                clearTimeout(timeout)
                // setTimeout(() => store.commit('currentPage/addPageToState', data), 0) // wait for the page transition

                store.commit('currentPage/addPageToState', data)
                store.commit('isReady', true)
                router.app.$Progress.finish()
                return next()
            })
            .catch(() => {
                store.commit('isReady', true)
                router.app.$Progress.fail()
                return next()
            })
    }

    else if(cms) {
        store.dispatch('currentPage/fetchMenuItem', { path: to.path, cms: parseInt(cms) })
            .then(data => {
                clearTimeout(timeout)
                // setTimeout(() => store.commit('currentPage/addPageToState', data), 0) // wait for the page transition

                store.commit('currentPage/addPageToState', data.page)
                store.commit('isReady', true)
                router.app.$Progress.finish()
                return next()
            })
            .catch(() => {
                store.commit('isReady', true)
                router.app.$Progress.fail()
                return next()
            })
    } else {
        next()
    }

})

router.afterEach(() => {
    // NProgress.done()
    router.app.$Progress.finish()
})
